var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSetting2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/setting-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "setting-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4007 6.1463C12.194 6.1463 11.7007 5.29297 12.3007 4.2463C12.6473 3.63963 12.4407 2.8663 11.834 2.51963L10.6807 1.85963C10.154 1.5463 9.47398 1.73297 9.16065 2.25963L9.08732 2.3863C8.48732 3.43297 7.50065 3.43297 6.89398 2.3863L6.82065 2.25963C6.52065 1.73297 5.84065 1.5463 5.31398 1.85963L4.16065 2.51963C3.55398 2.8663 3.34732 3.6463 3.69398 4.25297C4.30065 5.29297 3.80732 6.1463 2.60065 6.1463C1.90732 6.1463 1.33398 6.71297 1.33398 7.41297V8.5863C1.33398 9.27963 1.90065 9.85297 2.60065 9.85297C3.80732 9.85297 4.30065 10.7063 3.69398 11.753C3.34732 12.3596 3.55398 13.133 4.16065 13.4796L5.31398 14.1396C5.84065 14.453 6.52065 14.2663 6.83398 13.7396L6.90732 13.613C7.50732 12.5663 8.49398 12.5663 9.10065 13.613L9.17398 13.7396C9.48732 14.2663 10.1673 14.453 10.694 14.1396L11.8473 13.4796C12.454 13.133 12.6607 12.353 12.314 11.753C11.7073 10.7063 12.2007 9.85297 13.4073 9.85297C14.1007 9.85297 14.674 9.2863 14.674 8.5863V7.41297C14.6673 6.71963 14.1007 6.1463 13.4007 6.1463ZM8.00065 10.1663C6.80732 10.1663 5.83398 9.19297 5.83398 7.99963C5.83398 6.8063 6.80732 5.83297 8.00065 5.83297C9.19398 5.83297 10.1673 6.8063 10.1673 7.99963C10.1673 9.19297 9.19398 10.1663 8.00065 10.1663Z",
    stroke: "#4A5467",
    strokeWidth: 1.33
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSetting2);
export default __webpack_public_path__ + "static/media/ic-setting-2.5b03b2b03fa9e1af61d8ccbaa3aa3417.svg";
export { ForwardRef as ReactComponent };